export default "__VITE_ASSET__5caaee0a__"